import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { useGetPhoneNumber } from '~/queries/phoneNumberQueries'

import { PhoneNumber } from '@mangovoice/types'

import { StorageKeys } from './StorageKeys'

const lastUsedOutboundPhoneNumberAtom = atomWithStorage<PhoneNumber | null>(
  StorageKeys.LastUsedOutboundPhoneNumber,
  null,
)
const useLastOutboundPhoneNumber = (): [
  PhoneNumber | null,
  (phoneNumber: PhoneNumber | null) => void,
] => {
  const [lastUsedOutboundPhoneNumber, setLastUsedOutboundPhoneNumber] = useAtom(
    lastUsedOutboundPhoneNumberAtom,
  )
  const lastUsedId = lastUsedOutboundPhoneNumber?.id ?? 0
  const { data: phone, isError } = useGetPhoneNumber({
    phoneNumberId: lastUsedId,
  })
  if (isError || !phone) {
    return [null, setLastUsedOutboundPhoneNumber]
  } else {
    return [phone, setLastUsedOutboundPhoneNumber]
  }
}

export { useLastOutboundPhoneNumber }
